<template>
<div class="contentBox demandListPage">
    <div class="pageTitle">
        <h1>点播视频</h1>
    </div>
    <div class="pageTitle">
        <div class="filterBox">
            <span>共{{pageCount}}个点播</span>
        </div>
        <div class="searchBox">
            <button class="buyBtn" @click="jumpAdd()">
                <img src="../../assets/plusIcon.svg" alt />新增点播
            </button>
        </div>
    </div>
    <div class="demandListBoxWrap">
        <div class="liveListBox">
            <template v-for="(item, index) in vodData">
                <div class="listItem" :key="index">
                    <!--<i class="videoBtn"></i>-->
                    <div class="listImgIcon">
                        <img :src="item.poster" alt="" />
                    </div>
                    <a href="javascript:;" class="courseName">{{ item.title }}</a>
                    <div class="timeWrap">
                        <div class="time">
                            <span>时间：</span>
                            <span>{{ item.createTime }}</span>
                        </div>
                    </div>
                    <div class="operateBox">
                        <div class="operateItem" @click="jumpPage('/onDemand/file', item.vodId)">
                            <div class="imgIcon">
                                <img src="../../assets/liveIcon.svg" class="normal" alt=""/>
                                <img src="../../assets/liveIcon-blue.svg" class="hover" alt=""/>
                                <!--<img src="../../assets/editIcon.svg" class="normal" alt="" />
                                <img src="../../assets/editIcon-blue.svg" class="hover" alt="" />-->
                            </div>
                            <a href="javascript:;">文件管理</a>
                        </div>
                        <div class="operateItem shareOperate" @click="jumpPage('/onDemand/share',item.vodId)">
                            <div class="imgIcon">
                                <img src="../../assets/shareIcon.svg" class="normal" alt="" />
                                <img src="../../assets/shareIcon-blue.svg" class="hover" alt="" />
                            </div>
                            <a href="javascript:;">分享</a>
                        </div>
                        <div class="operateItem" @click="jumpPage('/onDemand/statistics',item.vodId)">
                            <div class="imgIcon">
                                <img src="../../assets/dataIcon.svg" class="normal" alt="" />
                                <img src="../../assets/dataIcon-blue.svg" class="hover" alt="" />
                            </div>
                            <a href="javascript:;">访问统计</a>
                        </div>
                        <div class="moreBox">
                            <div class="moreOperate">
                                <div class="moreOperateMain">
                                    <div class="moreItem editItem" @click="jumpPage('/onDemand/edit',item.vodId)">
                                        <span class="icon"></span>编辑
                                    </div>
                                    <div class="moreItem lockItem" v-if="item.status<4" @click="lock(item)">
                                        <span class="icon"></span>锁定
                                    </div>
                                    <div class="moreItem lockItem" v-if="item.status>=4" @click="lock(item)">
                                      <span class="icon"></span>解锁
                                    </div>
                                    <div class="moreItem deleteItem" @click="remove(item)">
                                        <span class="icon"></span>删除
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>

    <div class="listPrompt">
        <!-- 无列表显示 -->
        <div class="noListMessIcon NoInformation" v-if="vodData.length === 0">暂无信息</div>
    </div>
    <div class="paginationBox" v-if="vodData.length > pageSize">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="currentTotal" prev-text="上一页" next-text="下一页"></el-pagination>
    </div>
</div>
</template>

<script>
    import common from '../../common.vue';
    import moment from 'moment';
    const GET_VOD_LIST_URL =  common._BASE_ + 'vod/vodList';

    export default {
        name: "DemandList",
        data() {
            return {
                searchVal: '',
                searchFocus: false,
                currentPage: 1,
                pageSize: 12,
                currentTotal: 0,
                vodData: [],
                pageCount: 0,
                demandListDataSorce: [],
                demandSort: "",
                demandSortOptions: [{
                    value: "按照我排序1",
                    label: "按照我排序1",
                },
                    {
                        value: "按照我排序2",
                        label: "按照我排序2",
                    },
                ],

            };
        },
        methods: {
            loadVod(pageNo, pageSize) {

                let data = Object.assign({pageNo: pageNo, pageSize: pageSize}), _this = this;
                _this.$axios.post(GET_VOD_LIST_URL, this.$qs.stringify(data)).then(function (res) {
                    let r = res.data;
                    console.log(r);
                    parseInt(r.code) < 0 && _this.jumpPage('/login');
                    _this.vodData = res.data.data;
                    _this.pageCount = res.data.count;
                });
            },
            formatVod: function(vodList){
                let vods = vodList || [];
                (vods).forEach(function(item){
                    item.time = moment(item.lastActive || item.createTime).format("YYYY-MM-DD HH:mm");
                });
                this.vodData = vods;
            },
            lock: function (row){
                let _this = this;
                console.log(row);
                if(row.status === 9){
                  _this.$message({
                    message: '超管锁定用户无法操作',
                    type: 'error'
                  });
                }else{
                  if (row.status === 1) {
                    // ajax请求，改变视频的锁定状态

                    let _this = this;
                    let  data = Object.assign({ids:row.vodId, status:4});


                    _this.$axios.post(common.LOCK_VOD_URL, this.$qs.stringify(data)).then(function (res) {
                      console.log(res);
                      _this.$message({
                        message: '锁定成功',
                        type: 'success'
                      });
                      row.status = 4;
                    });


                  } else {
                    // ajax请求，改变视频的禁播状态
                    let _this = this;
                    let  data = Object.assign({ids:row.vodId, status:1});


                    _this.$axios.post(common.LOCK_VOD_URL, this.$qs.stringify(data)).then(function (res) {
                      console.log(res);
                      _this.$message({
                        message: '解锁成功',
                        type: 'success'
                      });
                    });
                    row.status = 1;
                  }
                }
            },
            remove(row){
              let _this = this;
              _this.$confirm('此操作将永久删除该点播及视频, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                _this.$axios.post(common.DELETE_VOD_URL, this.$qs.stringify(
                    {
                      vodId: row.vodId
                    }
                )).then(function (res) {
                  let r = res.data;
                  parseInt(r.code) < 0 && _this.jumpPage('/login');
                  _this.loadVod();
                  _this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });

                });

              });
            },
            jumpPage(path, id) {
                    this.$router.push(`${path}` + '/' + id);
            },
            jumpAdd(){
                this.$router.push({path: '/onDemand/add'});
            },
            jumpEdit(id) {
                this.$router.push({path: '/onDemand/edit', query: {id: id}});
            },
            focusInput() {
                this.searchFocus = true;
            },
            inputBlur() {
                this.searchFocus = false;
            },

            handleSizeChange(val) {
                this.pageSize = val;
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                console.log(`当前页: ${val}`);
            }
        },

        mounted() {
            this.loadVod();
        },
    };
</script> 

<style lang="less">
.listImgIcon{
  img{
    width: 100%;
  }
}
.demandListPage {
    .pageTitle {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        h1 {
            height: 20px;
            line-height: 24px;
            font-size: 20px;
            font-weight: bold;
            color: #221816;
        }

        .filterBox {
            .el-select .el-input__inner::-webkit-input-placeholder {
                color: #33363f;
            }

            .el-select .el-input__inner::-moz-input-placeholder {
                color: #33363f;
            }

            .el-select .el-input__inner::-ms-input-placeholder {
                color: #33363f;
            }
        }

        .searchBox {
            position: relative;
            display: flex;

            .search {
                width: 437px;
                height: 40px;
                border: solid 1px #e8e8e8;
                background: #fff;
                border-radius: 6px;
                padding-left: 12px;
            }

            .search:focus {
                border: 1px solid #306ff6;
            }
        }

        .buyBtn {
            width: 137px;
            height: 40px;
            background: #076eff;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            margin-left: 10px;

            img {
                margin-right: 6px;
            }
        }

        .buyBtn:hover {
            background: #4aa3f8;
        }

        .filterSelect {
            width: 140px;
            margin-right: 10px;
        }

        span {
            color: #a2a9ab;
        }
    }

    // .demandListBoxWrap {
    //     height: 850px;
    // }

    .liveListBox {
        display: flex;
        flex-wrap: wrap;

        .listItem {
            margin-right: 30px;
            margin-bottom: 20px;
        }

        .listItem:nth-child(4n + 4) {
            margin-right: 0;
        }

        .courseName {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-bottom: 0;
        }

        .timeWrap {
            border-top: none;
        }

        .operateBox {
            height: 38px;
            display: flex;
            align-items: center;
            border-top: 1px solid #e8e8e8;
            padding-left: 10px;
            position: relative;

            .operateItem {
                display: flex;
                align-items: center;
                font-size: 12px;
                line-height: 28px;
                color: #33363f;

                .imgIcon {
                    width: 12px;
                    height: 12px;
                    margin-right: 4px;
                    position: relative;

                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                    }

                    img.hover {
                        display: none;
                    }
                }
            }

            .operateItem:hover {
                .imgIcon {
                    img.normal {
                        display: none;
                    }

                    img.hover {
                        display: block;
                    }
                }
            }

            .shareOperate {
                margin: 0 18px;
            }

            .moreBox {
                width: 33px;
                height: 38px;
                border-left: 1px solid #e8e8e8;
                position: absolute;
                right: 0;
                bottom: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                background: url("../../assets/moreIcon.svg") no-repeat center center;
                z-index: 99;
                cursor: pointer;
            }

            .moreBox:hover {
                background: #306ff6 url("../../assets/moreIcon-white.svg") no-repeat center center;

                .moreOperate {
                    display: block;
                }
            }

            .moreOperate {
                width: 102px;
                height: 80px;
                position: absolute;
                top: 0;
                right: -102px;
                display: none;
                z-index: 99;

                .moreOperateMain {
                    width: 100px;
                    height: 80px;
                    margin-left: 2px;
                    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
                    font-size: 12px;
                    line-height: 40px;
                }

                .moreItem {
                    width: 100px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    color: #55565f;
                    background: #fff;

                    span.icon {
                        width: 14px;
                        height: 12px;
                        display: inline-block;
                        margin-right: 8px;
                        margin-left: 19px;
                    }
                }

                .moreItem:hover {
                    color: #221816;
                    background: #f5f6f7;
                }

                .moreItem.editItem span.icon {
                    background: url("../../assets/edit-gray.svg") center center no-repeat;
                }

                .moreItem.demandItem span.icon {
                    background: url("../../assets/demand-gray.svg") center center no-repeat;
                }

                .moreItem.lockItem span.icon {
                    background: url("../../assets/lock-gray.svg") center center no-repeat;
                }

                .moreItem.deleteItem span.icon {
                    background: url("../../assets/delete-gray.svg") center center no-repeat;
                }

                .moreItem.editItem:hover span.icon {
                    background: url("../../assets/edit-black.svg") center center no-repeat;
                }

                .moreItem.demandItem:hover span.icon {
                    background: url("../../assets/demand-black.svg") center center no-repeat;
                }

                .moreItem.lockItem:hover span.icon {
                    background: url("../../assets/lock-black.svg") center center no-repeat;
                }

                .moreItem.edit span.icon {
                  background: url("../../assets/editIcon.svg") center center no-repeat;
                }
                .moreItem.edit:hover span.icon {
                  background: url("../../assets/editIcon-blue.svg") center center no-repeat;
                }

                .moreItem.deleteItem:hover span.icon {
                    background: url("../../assets/delete-black.svg") center center no-repeat;
                }
            }
        }
    }
}
</style>